// routes/admin/PushOverviewPage.tsx
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabaseClient";
import PushOverviewForUser from "./PushOverviewForUser";

type User = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
};

export default function PushOverviewPage() {
  const { userId } = useParams<{ userId: string }>();
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    const load = async () => {
      const { data, error } = await supabase
        .from("profiles")
        .select("id, first_name, last_name, email")
        .eq("id", userId)
        .single();
      if (!error) setUser(data);
      setLoading(false);
    };
    load();
  }, [userId]);

  if (loading) return <p className="p-6 text-slate-400">Lade Nutzer …</p>;
  if (!user)
    return <p className="p-6 text-red-400">❌ Nutzer nicht gefunden.</p>;

  return (
    <div className="max-w-4xl mx-auto mt-10 p-6">
      <h1 className="text-2xl font-bold text-sky-400 mb-2">
        📬 Push-Tokens für {user.first_name} {user.last_name}
      </h1>
      <p className="text-sm text-slate-400 mb-6">{user.email}</p>

      <PushOverviewForUser userId={user.id} />
    </div>
  );
}
